import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface SurveyLocalizedTextDTO {
  text: string;
}

export class SurveyLocalizedText {
  readonly isSurveyLocalizedTextSurveyLocalizedText: boolean = true;

  readonly text: string;

  static readonly constraints = {
    "text": {
      "maxSize": 30000,
      
      
      
      
    }
  }

  constructor(
  text: string
  ) {
    SurveyLocalizedText.validateText(text);
    this.text = text;
  }

  static fromDTO(dto: SurveyLocalizedTextDTO): SurveyLocalizedText {
    const text = getString(dto, "text", InvalidSurveyLocalizedTextTextError);
    return new SurveyLocalizedText(
      text
    );
  }

  toDTO(): SurveyLocalizedTextDTO {
    const dto: SurveyLocalizedTextDTO = {
        text: this.text
    };
    return dto;
  }
  private static validateText = (text: string): void => {
    if(text.length > 30000) {
      throw new InvalidSurveyLocalizedTextTextMaxSizeError(
        30000,
        `Attribute text is too long. Size is ${text.length}. Max size is 30000.`
      );
    }
      if(text.trim().length === 0) {
        throw new InvalidSurveyLocalizedTextTextNonEmptyError(
          `Attribute text cannot be an empty string.`
        );
      }
  }
  
}

SurveyLocalizedText.prototype.toString = function toString(): string {
  return `SurveyLocalizedText(text='${this.text}')`;
};

export class InvalidSurveyLocalizedTextError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLocalizedTextError";
  }
}
export class InvalidSurveyLocalizedTextTextError extends InvalidSurveyLocalizedTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLocalizedTextTextError";
  }
}

export class InvalidSurveyLocalizedTextTextMaxSizeError extends InvalidSurveyLocalizedTextTextError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLocalizedTextTextMaxSizeError";
  }
}

export class InvalidSurveyLocalizedTextTextNonEmptyError extends InvalidSurveyLocalizedTextTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLocalizedTextTextNonEmptyError";
  }
}
